import { CSSProperties, useEffect, useMemo, useState } from "react"
import API from "./API"
import { AdminQueryProduct } from "../../backend/src/api/dto"
import { Link } from "react-router"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { DndContext, KeyboardSensor, MouseSensor, TouchSensor, closestCenter, type DragEndEvent, type UniqueIdentifier, useSensor, useSensors } from '@dnd-kit/core'
import { restrictToVerticalAxis } from '@dnd-kit/modifiers'
import { arrayMove, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

function Products() {

    const [data, setData] = useState<AdminQueryProduct[]>([])

    useEffect(() => {
        API.getProducts().then(res => {
            setData(res)
        })
    }, [])

    function handleDragEnd(event: DragEndEvent) {
        const { active, over } = event
        console.log({ active, over });
        if (active && over && active.id !== over.id) {
            setData(data => {
                const oldIndex = data.findIndex(item => 'product-' + item.productId === active.id)
                const newIndex = data.findIndex(item => 'product-' + item.productId === over.id)
                const newArray = arrayMove(data, oldIndex, newIndex);
                API.sortOrder('product', newArray.map(item => item.productId));
                return newArray
            })
        }
    }

    const sensors = useSensors(
        useSensor(MouseSensor, {}),
        useSensor(TouchSensor, {}),
        useSensor(KeyboardSensor, {})
    )

    const dataIds = useMemo<UniqueIdentifier[]>(
        () => data?.map(({ productId }) => 'product-' + productId),
        [data]
    );

    return (
        <div className="p-3">
            <div className="card">
                <div className="card-header" style={{ height: '55px' }}>
                    <div className="row">
                        <div className="col-6">
                            <h5 className="mt-2">
                                <FontAwesomeIcon fixedWidth icon={["fas", "umbrella"]} /> Produkty
                            </h5>
                        </div>
                        <div className="col-6 text-end">
                            <Link to="/dashboard/product/0" className="btn btn-success"><FontAwesomeIcon fixedWidth icon={["fas", "plus"]} /> Pridať produkt</Link>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <DndContext collisionDetection={closestCenter} modifiers={[restrictToVerticalAxis]} onDragEnd={handleDragEnd} sensors={sensors}>
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th style={{ width: '50px' }}></th>
                                    <th style={{ width: '300px' }}>Meno</th>
                                    <th>Popis</th>
                                    <th className="text-center" style={{ width: '110px' }}>Stav</th>
                                    <th className="text-center" style={{ width: '110px' }}>Akcia</th>
                                </tr>
                            </thead>
                            <tbody>
                                <SortableContext items={dataIds} strategy={verticalListSortingStrategy}>
                                    {
                                        data.map(product => {
                                            return (
                                                <DraggableRow key={'product-' + product.productId} product={product} />
                                            )
                                        })
                                    }
                                </SortableContext>
                            </tbody>
                        </table>
                    </DndContext>
                </div>
            </div>
        </div>
    )
}



function DraggableRow({ product }: { product: AdminQueryProduct }) {
    const { transform, transition, setNodeRef, isDragging, attributes, listeners } = useSortable({
        id: 'product-' + product.productId,
    })

    const style: CSSProperties = {
        transform: CSS.Transform.toString(transform),
        transition: transition,
        opacity: isDragging ? 0.8 : 1,
        zIndex: isDragging ? 1 : 0,
        position: 'relative',
    }
    return (
        <tr ref={setNodeRef} style={style}>
            <td className="text-center">
                <div {...attributes} {...listeners}>
                    <FontAwesomeIcon fixedWidth icon={["fas", "grip-vertical"]} />
                </div>
            </td>
            <td>{product.name}</td>
            <td>{product.description}</td>
            <td className="text-center">{product.status ? <span className="text-success">Aktívny</span> : <span className="text-danger">Neaktívny</span>}</td>
            <td className="text-center"><Link className="btn btn-primary btn-sm" to={"/dashboard/product/" + product.productId}><FontAwesomeIcon fixedWidth icon={["fas", "pen"]} /> Upraviť</Link></td>
        </tr>
    )
}



export default Products